/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnfilteredTag
 */
export interface UnfilteredTag {
    /**
     * 
     * @type {number}
     * @memberof UnfilteredTag
     */
    id: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UnfilteredTag
     */
    roots: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof UnfilteredTag
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UnfilteredTag
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnfilteredTag
     */
    color?: string;
}

export function UnfilteredTagFromJSON(json: any): UnfilteredTag {
    return UnfilteredTagFromJSONTyped(json, false);
}

export function UnfilteredTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnfilteredTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'roots': json['roots'],
        'name': json['name'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'color': !exists(json, 'color') ? undefined : json['color'],
    };
}

export function UnfilteredTagToJSON(value?: UnfilteredTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'roots': value.roots,
        'name': value.name,
        'shared': value.shared,
        'color': value.color,
    };
}


